import { Trans } from "react-i18next";

export function TechnicalRepairHint({ className }: { className?: string }) {
  return (
    <div className={`text-sm rounded p-3 bg-gray-100 mt-2 ${className ? className : ""}`}>
      <Trans
        components={{
          tel: <a href={"tel:021191358221"} />,
          reifenwechsel: (
            <a
              href={"https://www.ayvens.com/de-de/kundenservice/dienstwagenfahrer/reifenservice"}
              target={"_blank"}
              rel="noopener noreferrer"
            />
          ),
        }}
        i18nKey="garageList.filters.premiumServices.technical-repair-info"
      />
    </div>
  );
}
